// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  orientationId: __t.string(),
  passingScorePct: __t.option(__t.u32()),
  showAnswersAtEnd: __t.bool(),
  autoReassignOnFail: __t.bool(),
  maxAttempts: __t.option(__t.u32()),
};
